// import { DataGrid, GridToolbar } from '@mui/x-data-grid';
// import Iconify from '../../ui-component/iconify';
// import TableStyle from '../../ui-component/TableStyle';
// import { useState, useEffect } from 'react';
// import {
//   Stack,
//   Button,
//   Container,
//   Typography,
//   Box,
//   Card,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle
// } from '@mui/material';
// import MenuItem from '@mui/material/MenuItem';
// import { getApi, postApi, deleteManyApi } from 'views/services/api';
// import DeleteIcon from '@mui/icons-material/Delete';
// import DeleteItem from './Components/DeleteItem';
// import AddItems from './AddItems';
// import Tab from '@mui/material/Tab';
// import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';
// import TabPanel from '@mui/lab/TabPanel';
// import { useNavigate } from 'react-router';
// import ShowSeparateFoodBill from './ShowSeparateFoodBill';
// import * as XLSX from 'xlsx';
// import ShowSeparateMenuList from './ShowSeparateMenuList';
// import EditIcon from '@mui/icons-material/Edit';
// import { toast } from 'react-toastify';

// const Restaurant = () => {
//   const navigate = useNavigate();
//   const [openAdd, setOpenAdd] = useState(false);
//   const [itemsData, setItemsData] = useState([]);
//   const [firstTabOption, setFirstTabOption] = useState('1');
//   const [openDelete, setOpenDelete] = useState(false);
//   const [id, setId] = useState('');
//   const [currentItem, setCurrentItem] = useState(null);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [rowSelectionModel, setRowSelectionModel] = useState([]);
//   const [openImportModal, setOpenImportModal] = useState(false);
//   const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

//   const hotel = JSON.parse(localStorage.getItem('hotelData'));
//   const baseUrl = process.env.REACT_APP_BASE_URL;

//   const fetchItemsData = async () => {
//     try {
//       const response = await getApi(`api/restaurant/viewallitems/${hotel?.hotelId}`);
//       const formattedData = response?.data?.restaurantData.map((item) => ({
//         ...item,
//         itemImage: item.itemImage.split('/').pop()
//       }));
//       setItemsData(formattedData);
//     } catch (error) {
//       console.error('Error fetching items:', error);
//     }
//   };

//   useEffect(() => {
//     fetchItemsData();
//   }, [openAdd, openDelete]);

//   const handleOpenDeleteItem = (itemId) => {
//     setId(itemId);
//     setOpenDelete(true);
//   };

//   const handleOpenAdd = () => {
//     setOpenAdd(true);
//   };

//   const handleCloseAdd = () => {
//     setOpenAdd(false);
//   };

//   const handleCloseDeleteItem = () => {
//     setOpenDelete(false);
//   };

//   const handleMakeOrder = () => {
//     navigate('/dashboard/separatefood/addfood');
//   };

//   const handleFirstTabChange = (event, newValue) => {
//     setFirstTabOption(newValue);
//   };

//   const handleFileUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = async (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: 'array' });
//       const sheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[sheetName];
//       const jsonData = XLSX.utils.sheet_to_json(worksheet);

//       try {
//         const response = await postApi(`api/restaurant/importitems/${hotel?.hotelId}`, jsonData);
//         if (response.ok) {
//           fetchItemsData();
//         } else {
//           console.error('Failed to import items');
//         }
//       } catch (error) {
//         console.error('Error:', error);
//       }
//     };
//     reader.readAsArrayBuffer(file);
//   };

//   const handleOpenMenu = () => {
//     const hotelId = hotel?.hotelId;
//     const menuUrl = `${window.location.origin}/menu.html?hotelId=${hotelId}`;
//     window.open(menuUrl, '_blank');
//   };

//   const handleEditItem = (itemId) => {
//     const item = itemsData.find((item) => item._id === itemId);
//     setCurrentItem(item);
//     setOpenAdd(true);
//   };

//   const onHandleChange = (newRowSelectionModel) => {
//     setRowSelectionModel(newRowSelectionModel);
//     console.log('Selected newRowSelectionModel:', newRowSelectionModel);
//   };

//   const handleRowSelectionChange = (newRowSelectionModel) => {
//     console.log('=>', newRowSelectionModel);
//     onHandleChange(newRowSelectionModel);
//   };

//   const handleDeleteSelectedItems = () => {
//     setOpenConfirmDelete(true);
//   };

//   const handleConfirmDeleteItems = async () => {
//     try {
//       const response = await deleteManyApi(`api/restaurant/deletemany`, { data: { ids: rowSelectionModel } });
//       console.log('response for many delete ===============>', response);
//       toast.success('Item Deleted Successfully');
//       fetchItemsData();
//     } catch (error) {
//       console.error('Failed to delete items', error);
//     } finally {
//       setOpenConfirmDelete(false);
//     }
//   };

//   const columns = [
//     {
//       field: 'itemImage',
//       headerName: 'Item Image',
//       flex: 1,
//       renderCell: (params) => (
//         <div style={{ display: 'flex', alignItems: 'center' }}>
//           <a href={`${baseUrl}api/uploads/restaurant/Item/${params.value}`} target="_blank" rel="noopener noreferrer">
//             {params.value}
//           </a>
//         </div>
//       )
//     },
//     {
//       field: 'category',
//       headerName: 'Category',
//       flex: 1,
//       cellClassName: 'name-column--cell--capitalize'
//     },
//     {
//       field: 'itemName',
//       headerName: 'Item Name',
//       flex: 1,
//       cellClassName: 'name-column--cell--capitalize'
//     },
//     {
//       field: 'amount',
//       headerName: 'Amount',
//       flex: 1,
//       renderCell: (params) => <Box>Rs {params.value}</Box>
//     },
//     {
//       field: 'action',
//       headerName: 'Action',
//       flex: 1,
//       renderCell: (params) => (
//         <>
//           <EditIcon
//             onClick={() => handleEditItem(params.row._id)}
//             style={{ marginRight: '8px', color: 'blue', cursor: 'pointer' }}
//           />
//           <DeleteIcon
//             onClick={() => handleOpenDeleteItem(params.row._id)}
//             style={{ marginRight: '8px', color: 'red', cursor: 'pointer' }}
//           />
//         </>
//       )
//     }
//   ];

//   const handleOpenImportModal = () => {
//     setOpenImportModal(true);
//   };

//   const handleCloseImportModal = () => {
//     setOpenImportModal(false);
//     fetchItemsData();
//   };

//   return (
//     <>
//       <AddItems open={openAdd} handleClose={handleCloseAdd} currentItem={currentItem} />
//       <DeleteItem open={openDelete} handleClose={handleCloseDeleteItem} id={id} />

//       <Dialog open={openConfirmDelete} onClose={() => setOpenConfirmDelete(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           <Typography>Are you sure you want to delete these items?</Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenConfirmDelete(false)} color="primary">Cancel</Button>
//           <Button onClick={handleConfirmDeleteItems} color="error" variant="contained">Confirm</Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={openImportModal} onClose={handleCloseImportModal} sx={{ minWidth: '500px', padding: '20px', borderRadius: '10px' }}>
//         <DialogTitle>Import Items File Form Here</DialogTitle>
//         <DialogContent>
//           <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
//             <Button variant="contained" component="label">
//               Download Sample File
//             </Button>

//             <Button variant="contained" component="label">
//               Upload File
//               <input type="file" accept=".xlsx, .xls" hidden onChange={handleFileUpload} />
//             </Button>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseImportModal} color="secondary">Cancel</Button>
//           <Button onClick={handleCloseImportModal} color="secondary">Save</Button>
//         </DialogActions>
//       </Dialog>

//       <TabContext value={firstTabOption}>
//         <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
//           <TabList value={firstTabOption} onChange={handleFirstTabChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary">
//             <Tab label="Food Items" value="1" />
//             <Tab label="Restaurant Food Invoice (Separate)" value="2" />
//           </TabList>
//           <Stack direction="row" alignItems="center" justifyContent="space-between">
//             <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
//               <Button variant="contained" sx={{ marginRight: '5px' }} startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleMakeOrder}>
//                 Make Order
//               </Button>
//               <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAdd}>
//                 New item
//               </Button>
//               <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenImportModal}>
//                 Import
//               </Button>
//               <Button variant="contained" startIcon={<Iconify icon="eva:menu-fill" />} onClick={handleOpenMenu}>
//                 Open Menu
//               </Button>
//               <Button variant="contained" startIcon={<DeleteIcon />} disabled={rowSelectionModel.length === 0} onClick={handleDeleteSelectedItems}>
//                 Delete
//               </Button>
//             </Stack>
//           </Stack>
//         </Box>
//         <TabPanel value="1">
//           <Container>
//             <TableStyle>
//               <Box width="100%">
//                 <Card style={{ height: '600px', paddingTop: '15px' }}>
//                   {itemsData && (
//                     <>
//                       <Typography variant="h4" sx={{ margin: '2px 15px' }}>
//                         Items ({itemsData?.length})
//                       </Typography>
//                       <DataGrid
//                         rows={itemsData}
//                         columns={columns}
//                         checkboxSelection
//                         getRowId={(row) => row._id}
//                         onRowSelectionModelChange={handleRowSelectionChange}
//                         rowSelectionModel={rowSelectionModel}
//                       />
//                     </>
//                   )}
//                 </Card>
//               </Box>
//             </TableStyle>
//           </Container>
//         </TabPanel>
//         <TabPanel value="2">
//           <ShowSeparateFoodBill />
//         </TabPanel>
//       </TabContext>
//     </>
//   );
// };

// export default Restaurant;




import { DataGrid } from '@mui/x-data-grid';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState, useEffect } from 'react';
import {
  Stack,
  Button,
  Container,
  Typography,
  Box,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { getApi, postApi, deleteManyApi } from 'views/services/api';
import DeleteItem from './Components/DeleteItem';
import AddItems from './AddItems';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate } from 'react-router';
import ShowSeparateFoodBill from './ShowSeparateFoodBill';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import sampleFile from 'assets/sampleFile/sampleFile.xlsx';


const Restaurant = () => {
  const navigate = useNavigate();
  const [openAdd, setOpenAdd] = useState(false);
  const [itemsData, setItemsData] = useState([]);
  const [firstTabOption, setFirstTabOption] = useState('1');
  const [openDelete, setOpenDelete] = useState(false);
  const [id, setId] = useState('');
  const [currentItem, setCurrentItem] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const fetchItemsData = async () => {
    try {
      const response = await getApi(`api/restaurant/viewallitems/${hotel?.hotelId}`);
      const formattedData = response?.data?.restaurantData.map((item) => ({
        ...item,
        itemImage: item.itemImage.split('/').pop()
      }));
      setItemsData(formattedData);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  useEffect(() => {
    fetchItemsData();
  }, [openAdd, openDelete]);

  const handleOpenDeleteItem = (itemId) => {
    setId(itemId);
    setOpenDelete(true);
  };

  const handleOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
  };

  const handleCloseDeleteItem = () => {
    setOpenDelete(false);
  };

  const handleMakeOrder = () => {
    navigate('/dashboard/separatefood/addfood');
  };

  const handleFirstTabChange = (event, newValue) => {
    setFirstTabOption(newValue);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      try {
        const response = await postApi(`api/restaurant/importitems/${hotel?.hotelId}`, jsonData);
        if (response.ok) {
          fetchItemsData();
        } else {
          console.error('Failed to import items');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleOpenMenu = () => {
    const hotelId = hotel?.hotelId;
    const menuUrl = `${window.location.origin}/menu.html?hotelId=${hotelId}`;
    window.open(menuUrl, '_blank');
  };

  const handleEditItem = (itemId) => {
    const item = itemsData.find((item) => item._id === itemId);
    setCurrentItem(item);
    setOpenAdd(true);
  };

  const onHandleChange = (newRowSelectionModel) => {
    setRowSelectionModel(newRowSelectionModel);
    console.log('Selected newRowSelectionModel:', newRowSelectionModel);
  };

  const handleRowSelectionChange = (newRowSelectionModel) => {
    console.log('=>', newRowSelectionModel);
    onHandleChange(newRowSelectionModel);
  };

  const handleDeleteSelectedItems = () => {
    setOpenConfirmDelete(true);
  };

  const handleConfirmDeleteItems = async () => {
    try {
      const response = await deleteManyApi(`api/restaurant/deletemany`, { data: { ids: rowSelectionModel } });
      console.log('response for many delete ===============>', response);
      toast.success('Item Deleted Successfully');
      fetchItemsData();
    } catch (error) {
      console.error('Failed to delete items', error);
    } finally {
      setOpenConfirmDelete(false);
    }
  };

  const columns = [
    {
      field: 'itemImage',
      headerName: 'Item Image',
      flex: 1,
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <a href={`${baseUrl}api/uploads/restaurant/Item/${params.value}`} target="_blank" rel="noopener noreferrer">
            {params.value}
          </a>
        </div>
      )
    },
    {
      field: 'category',
      headerName: 'Category',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'itemName',
      headerName: 'Item Name',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      renderCell: (params) => <Box>Rs {params.value}</Box>
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => (
        <>
          <EditIcon
            onClick={() => handleEditItem(params.row._id)}
            style={{ marginRight: '8px', color: 'blue', cursor: 'pointer' }}
          />
          <DeleteIcon
            onClick={() => handleOpenDeleteItem(params.row._id)}
            style={{ marginRight: '8px', color: 'red', cursor: 'pointer' }}
          />
        </>
      )
    }
  ];

  const handleOpenImportModal = () => {
    setOpenImportModal(true);
  };

  const handleCloseImportModal = () => {
    setOpenImportModal(false);
    fetchItemsData();
  };

  return (
    <>
      <AddItems open={openAdd} handleClose={handleCloseAdd} currentItem={currentItem} />
      <DeleteItem open={openDelete} handleClose={handleCloseDeleteItem} id={id} />

      <Dialog open={openConfirmDelete} onClose={() => setOpenConfirmDelete(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete these items?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDelete(false)} color="primary">Cancel</Button>
          <Button onClick={handleConfirmDeleteItems} color="error" variant="contained">Confirm</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openImportModal} onClose={handleCloseImportModal} sx={{ minWidth: '500px', padding: '20px', borderRadius: '10px' }}>
        <DialogTitle>Download Sample File / Import MenuItems File Form Here</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
            <Button variant="contained" component="a" href={sampleFile} download>
              Download Sample File
            </Button>

            <Button variant="contained" component="label">
              Upload File
              <input type="file" accept=".xlsx, .xls" hidden onChange={handleFileUpload} />
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImportModal} color='error'>Cancel</Button>
          <Button onClick={handleCloseImportModal} color="secondary">Save</Button>
        </DialogActions>
      </Dialog>
      
       <TabContext value={firstTabOption}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
       <TabList value={firstTabOption} onChange={handleFirstTabChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary">
             <Tab label="Food Items" value="1" />
             <Tab label="Restaurant Food Invoice (Separate)" value="2" />
           </TabList>
           <Stack direction="row" alignItems="center" justifyContent="space-between">
             <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
               <Button variant="outlined" sx={{ marginRight: '5px' }} startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleMakeOrder}>
                 Make Order
               </Button>
               <Button variant="outlined" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAdd}>
                 New item
               </Button>
               <Button variant="outlined" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenImportModal}>
                 Import
               </Button>
               <Button variant="outlined" startIcon={<Iconify icon="eva:menu-fill" />} onClick={handleOpenMenu}>
                 Open Menu
               </Button>
               <Button variant="contained" startIcon={<DeleteIcon />} disabled={rowSelectionModel.length === 0} onClick={handleDeleteSelectedItems}>
                 Delete
               </Button>
             </Stack>
        </Stack>
         </Box>
         <TabPanel value="1">
          <Container>
            <TableStyle>
              <Box width="100%">
               <Card style={{ height: '600px', paddingTop: '15px' }}>
                {itemsData && (
                    <>
                      <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                        Items ({itemsData?.length})
                      </Typography>
                      <DataGrid
                        rows={itemsData}
                        columns={columns}
                        checkboxSelection
                        getRowId={(row) => row._id}
                        onRowSelectionModelChange={handleRowSelectionChange}
                        rowSelectionModel={rowSelectionModel}
                      />
                    </>
                  )}
                </Card>
              </Box>
            </TableStyle>
          </Container>
        </TabPanel>
        <TabPanel value="2">
          <ShowSeparateFoodBill />
        </TabPanel>
      </TabContext>

    </>
  );
};

export default Restaurant;





